/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createEmailReceiptRequest } from '../models/api_createEmailReceiptRequest';
import type { db_ListEmailReceiptsRow } from '../models/db_ListEmailReceiptsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Email {
    /**
     * Get a list of email receipts
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param search Search string
     * @returns db_ListEmailReceiptsRow OK
     * @throws ApiError
     */
    public static listEmailReceipts(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListEmailReceiptsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/emails/receipts',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Handle email receipt callback from GovUK Notify
     * @param body User ID
     * @returns any Created
     * @throws ApiError
     */
    public static createEmailReceipt(
        body: api_createEmailReceiptRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/emails/receipts',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
